import CommonLang from "./common.lang";

export default {
  common: CommonLang,
};
